<script lang="ts">
    
    import './global.scss';
    import './Services/i18n';
    import { Router, Route } from 'svelte-navigator';
    import { onMount } from 'svelte';
    import NoRoom from './Pages/NoRoom.svelte';
    import Room from './Pages/Room.svelte';
    import OrientationWarn from './Components/Shared/OrientationWarn.svelte';
    import { playerService, roomsService, screenOrientationService } from './Services';
      

    let showOrientationWarn = false;
    let isWindowFocused = true;
    
    onMount(() => {
        onWindowResize()

        onWindowFocus()

    });

    $: updateOrientationWarn($screenOrientationService);

    function onWindowResize() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    function updateOrientationWarn(angle: number) {
        showOrientationWarn = angle !== 0 && angle !== 180;
    }


    function onWindowFocus() {
        document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    async function handleVisibilityChange() {
        isWindowFocused = !document.hidden;
        playerService.statusConnection(isWindowFocused)
        
        if (isWindowFocused){
            //Obtenemos el array de números que han salido
            let tempString = window.localStorage.getItem('player');
            if(!tempString)
                return

            const player = JSON.parse(tempString);
            await roomsService.getCurrentGameInRoom(player.roomId)
            
        }

    }

</script>

<svelte:window
    on:resize={onWindowResize} />

{#if showOrientationWarn}
    <OrientationWarn />
{/if}

<Router primary={false}>

    <Route path="/room/:roomId" component={Room} />
    <Route path="*" component={NoRoom} />

</Router>
